<template>
  <div
    :class="[{ '_hidden': !visible }]"
    class="contextMenu"
    ref="contextMenu"
    v-click-outside="clickedOutside"
    :style="{
      left: positionX + 'px',
      top: positionY + 'px'
    }"
    >
    <slot />
  </div>
</template>

<script>
let $ = window.$

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    positionX: Number,
    positionY: Number
  },
  methods: {
    clickedOutside () {
      this.$emit('closeContextMenu')
    }
  },
  mounted () {
    $(this.$refs.contextMenu).appendTo('body')
  },
  beforeDestroy () {
    $(this.$refs.contextMenu).remove()
  }
}
</script>

<style lang="scss" scoped>
.contextMenu {
  position: absolute;
  z-index: 10000;
  .list-group-item {
    padding: 6px 10px;
  }
  &._hidden {
    display: none;
  }
}
</style>
